import Image, { type ImageProps } from "next/image";

import { BRAND_LOGO_ALT, BRAND_LOGO_DARK_SRC, BRAND_LOGO_SRC } from "@/lib/brand";
import { cn } from "@/lib/utils";

type BrandLogoProps = Omit<ImageProps, "src" | "alt"> & {
  alt?: string;
  surface?: "light" | "dark" | "theme";
};

export function BrandLogo({
  alt = BRAND_LOGO_ALT,
  className,
  surface = "theme",
  ...props
}: BrandLogoProps) {
  if (surface === "light") {
    return <Image {...props} src={BRAND_LOGO_SRC} alt={alt} className={className} />;
  }

  if (surface === "dark") {
    return (
      <Image
        {...props}
        src={BRAND_LOGO_DARK_SRC}
        alt={alt}
        className={className}
      />
    );
  }

  return (
    <>
      <Image
        {...props}
        src={BRAND_LOGO_SRC}
        alt={alt}
        className={cn("dark:hidden", className)}
      />
      <Image
        {...props}
        src={BRAND_LOGO_DARK_SRC}
        alt={alt}
        className={cn("hidden dark:block", className)}
      />
    </>
  );
}
